import * as squint_core from 'squint-cljs/core.js';
import elasticlunr from 'elasticlunr';
import * as str from 'squint-cljs/src/squint/string.js';
import * as clojure_DOT_string from 'squint-cljs/src/squint/string.js';
var tokenize = function (s) {
if (squint_core.not(s)) {
return []} else {
const candidate_tokens_1 = str.split(str.lower_case(str.trim(`${s??''}`)), /[\s\[\](){}]+/);
const long_all_punctuation_regex_2 = /^[^a-z0-9]{7,}$/;
const standalone_comment_regex_3 = /^;+$/;
const superfluous_punctutation_regex_4 = /^[.,]+|[.,]+$/;
const trim_superfluous_punctuation_5 = (function (candidate) {
return str.replace(candidate, superfluous_punctutation_regex_4, "");

});
return squint_core.reduce((function (tokens, candidate) {
if (squint_core.truth_((() => {
const or_6_7 = long_all_punctuation_regex_2.test(candidate);
if (squint_core.truth_(or_6_7)) {
return or_6_7} else {
return standalone_comment_regex_3.test(candidate)};

})())) {
return tokens} else {
const token_8 = trim_superfluous_punctuation_5(candidate);
if (squint_core.truth_(squint_core.seq(token_8))) {
return squint_core.conj(tokens, token_8)} else {
return tokens};
};

}), [], candidate_tokens_1);
};

};
var sub_tokenize = function (tokens) {
const split_char_regex_1 = /[\/:^._-]/;
const split_chars_regex_2 = /[\/:^._-]+/;
return squint_core.reduce((function (acc, token) {
if (squint_core.not(split_char_regex_1.test(token))) {
return acc} else {
return squint_core.into(acc, squint_core.remove((function (_PERCENT_1_SHARP_) {
return (squint_core.count(_PERCENT_1_SHARP_) === 0);

}), str.split(token, split_chars_regex_2)))};

}), [], tokens);

};
var tokenizer = function (s) {
const tokens_1 = tokenize(s);
return squint_core.into(tokens_1, sub_tokenize(tokens_1));

};
elasticlunr.tokenizer = tokenizer;
var build_search_index = function (index_items) {
const search_index_1 = elasticlunr((function (index) {
index.setRef("id");
index.addField("name");
index.addField("doc");
index.pipeline.reset();
return index.saveDocument(true);

}));
for (let G__2 of squint_core.iterable(index_items)) {
const item_3 = G__2;
search_index_1.addDoc(item_3)
};
return search_index_1;

};
var search = function (search_index, query) {
if (squint_core.truth_(search_index)) {
const exact_tokens_1 = tokenize(query);
const field_queries_2 = [({"field": "name", "boost": 10, "tokens": exact_tokens_1}), ({"field": "doc", "boost": 5, "tokens": exact_tokens_1})];
const query_results_3 = ({});
for (let G__4 of squint_core.iterable(field_queries_2)) {
const field_query_5 = G__4;
const search_config_6 = (() => {
const G__11363_7 = ({});
(G__11363_7[squint_core.get(field_query_5, "field")] = ({"boost": squint_core.get(field_query_5, "boost"), "bool": "OR", "expand": true}));
return G__11363_7;

})();
const temp__6897__auto___8 = search_index.fieldSearch(squint_core.get(field_query_5, "tokens"), squint_core.get(field_query_5, "field"), search_config_6);
if (squint_core.truth_(temp__6897__auto___8)) {
const field_search_results_9 = temp__6897__auto___8;
const boost_10 = squint_core.get(field_query_5, "boost");
for (let G__11 of squint_core.iterable(Object.keys(field_search_results_9))) {
const doc_ref_12 = G__11;
const current_value_13 = squint_core.get(field_search_results_9, doc_ref_12);
squint_core.assoc_BANG_(field_search_results_9, doc_ref_12, (current_value_13 * boost_10))
};
for (let G__14 of squint_core.iterable(Object.keys(field_search_results_9))) {
const doc_ref_15 = G__14;
((query_results_3[doc_ref_15] = ((() => {
const or_16_17 = query_results_3[doc_ref_15];
if (squint_core.truth_(or_16_17)) {
return or_16_17} else {
return 0};

})() + squint_core.get(field_search_results_9, doc_ref_15))),query_results_3)
}}
};
const results_18 = [];
for (let G__19 of squint_core.iterable(Object.keys(query_results_3))) {
const doc_ref_20 = G__19;
squint_core.conj_BANG_(results_18, ({"ref": doc_ref_20, "score": query_results_3[doc_ref_20]}))
};
results_18.sort((function (a, b) {
return (squint_core.get(b, "score") - squint_core.get(a, "score"));

}));
const results_with_docs_21 = squint_core.mapv((function (r) {
return ({"result": r, "doc": squint_core.get(search_index, "documentStore").getDoc(squint_core.get(r, "ref"))});

}), results_18);
const seen_22 = (new Set ([]));
return squint_core.reduce((function (acc, p__11364) {
const map___23_25 = p__11364;
const map___23_26 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___23_25))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___23_25))) ? (map___23_25) : (squint_core.seq_to_map_for_destructuring(map___23_25)))) : (map___23_25));
const n_27 = map___23_26;
const doc_28 = squint_core.get(map___23_26, "doc");
if (!squint_core.contains_QMARK_((new Set (["def", "namespace"])), squint_core.get(doc_28, "kind"))) {
return squint_core.conj(acc, n_27)} else {
const unique_id_29 = JSON.stringify(squint_core.select_keys(doc_28, ["kind", "name", "path", "namespace"]));
if (squint_core.contains_QMARK_(seen_22, unique_id_29)) {
return acc} else {
squint_core.conj_BANG_(seen_22, unique_id_29);
return squint_core.conj(acc, n_27);
};
};

}), [], results_with_docs_21);
};

};

export { tokenize, tokenizer, build_search_index, sub_tokenize, search }
